module.exports = __webpack_public_path__ + "img/image-23.82aced1c.webp";